import {WB_PeriodRow, WB_EntityRow, WB_PeriodCompanyRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import {IHierarchyNodeProvider, INode, INodeLogicalKey} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {esWB_Period} from "../PA.Core/PAdbSchema";
import * as _ from "lodash"
import {PeriodNodeProvider} from "./PeriodNodeProvider";

export class PeriodNode
    implements INode
{
    private periodRow
        : WB_PeriodRow
    private perProvider: PeriodNodeProvider

    private _bUseLogicalKey: boolean
    private _logicalKey: INodeLogicalKey

    private bTypesLoaded: boolean
    private dctEntity: {[wbEntityId: number]: WB_EntityRow}
    private dctEntityBySA: {[wbEntityId: number]: {[wbSalesAreaId: number]: WB_EntityRow}}



    constructor(perRow: WB_PeriodRow, provider: PeriodNodeProvider) {
        this.periodRow = perRow
        this.perProvider = provider

        this.bTypesLoaded = false
        this.dctEntity = {}
        this.dctEntityBySA = {}

        this._bUseLogicalKey = false
        this._logicalKey = {}


    }

    // Key
    get wbId(): number { return this.periodRow.cif.WB_PERIOD_ID }
    get provider(): IHierarchyNodeProvider { return this.perProvider }

    // Logical Identity
    get id_ui(): string { return this.periodRow.cif.PERIOD_ID  }
    get key_set(): string { return this.periodRow.cif.PERIOD_SET_ID }

    get bUseLogicalKey(): boolean {
        return this._bUseLogicalKey
    }
    get logicalKey(): INodeLogicalKey {
        return this._logicalKey
    }

    // Storage, needed to determine
    get mapperName(): string { return esWB_Period }

    // Other properties
    get node_name(): string { return this.periodRow.cif.PERIOD_NAME }


    isEntityType(wbEntityId: number, opts?: { wbSalesAreaIds?: number[] }): boolean {
        this.checkTypesLoaded()


        return wbEntityId in this.dctEntity;
    }

    get entityTypes(): WB_EntityRow[] {
        this.checkTypesLoaded()

        return _.values(this.dctEntity)
    }


    private checkTypesLoaded(){
        if(this.bTypesLoaded)
            return

        // Use provider to create Dictionaries
        this.dctEntity = _.keyBy(_.filter(this.provider.entityTypes, 
            a => a.cif.META_WB_ID === this.periodRow.cif.WB_PERIODM_ID), (b) => b.cif.WB_ENTITY_ID)

        this.bTypesLoaded = true

    }



}
